<template>
  <v-stepper :key="key" v-model="step" vertical>
    <v-stepper-step :complete="has(stepperVars.name)" step="1" editable>
      Name this community
    </v-stepper-step>

    <v-stepper-content step="1">
      <CommunityName
        :namespace="stepperVars.namespace"
        :name="stepperVars.name"
        :available_namespaces="available_namespaces"
        :check_name_availibility="check_name_availibility"
        @confirm="confirmName($event)"/>
    </v-stepper-content>

    <v-stepper-step :complete="has(stepperVars.kind)" step="2">
      Choose a community to start with
    </v-stepper-step>
    <v-stepper-content step="2">
      <CommunityType v-model="stepperVars.kind" @confirm="step = 3"></CommunityType>
    </v-stepper-content>

    <v-stepper-step :complete="has(stepperVars.query)" step="3" editable>Definition</v-stepper-step>
    <v-stepper-content step="3">
      <EditCommunity :kind="stepperVars.kind" v-model="stepperVars.query" @confirm="step = 4" nonempty>
      </EditCommunity>
    </v-stepper-content>

    <v-stepper-step step="4">Summary</v-stepper-step>
    <v-alert type="error" text v-if="alert_text">
     <pre>{{alert_text}}</pre>
    </v-alert>
    <v-stepper-content step="4">
      <v-card
        class="mb-12"
        color="grey lighten-1"
        height="200px"
        >
        {{ community }}
      </v-card>

      <v-btn color="primary" @click="confirm">
        Confirm
      </v-btn>

      <v-btn @click="cancel()" text>Cancel</v-btn>
    </v-stepper-content>
  </v-stepper>
</template>

<script>
    import CommunityName from "./CommunityName"
    import CommunityType from "./CommunityType"
    import EditCommunity from "./EditCommunity"
    import CommunityService from "../../services/community.service"

    const emptyStepperVars = {namespace: null, name: null, kind: null, query: null}
    export default {
        components: { CommunityName, CommunityType, EditCommunity },
        props: ['value', 'namespace', 'writable_namespaces', 'alert_text', 'check_name_availibility', 'with_namespace'],
        data () {
            return {
                steps: [],
                stepperVars: emptyStepperVars,
                step: 1,
                available_namespaces: [],
            }
        },
        computed: {
            key () {
                return this.$vnode.key
            },
            community () {
                let val = this.stepperVars;
                if (val.namespace) {
                  return { name: { namespace: val.namespace, name: val.name },
                           query: val.query }
                }
                else {
                  return { name: { namespace: null, name: val.name },
                           query: val.query }
                }
            }
        },
        methods: {
            has (field) {
                return field !== null && field !== "" && field !== undefined
            },
            cancel () {
                this.reset()
                this.$emit('cancel')
            },
            confirm () {
                this.$emit('confirm', this.community)
                this.reset()
            },
            confirmName (community_name_obj) {
              this.stepperVars.name = community_name_obj.name;
              this.stepperVars.namespace = community_name_obj.namespace;
              this.step = 2;
            },
            reset () {
                this.stepperVars = {...emptyStepperVars}
                this.step = 1
            }
        },
        mounted () {
            this.reset()
            if (this.writable_namespaces) {
                // we are provided with selectable list
                this.available_namespaces = this.writable_namespaces;
                if (this.available_namespaces.length) {
                  this.stepperVars.namespace = this.namespace;
                }
            }
        },
        watch: {
            // TODO remove/fix
            value: {
                handler (val) {
                    this.community = val
                },
                deep: true
            },
            namespace: function (newVal) {
                  this.stepperVars.namespace = this.namespace;
            }

        }
    }
</script>
